import React, { Component } from "react";
import { GameCard } from "../../components/card";
import { CardMove } from "../../components/modals";
import * as gameAction from "../../redux/game/action";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { Row, Col } from "reactstrap";
import Masonry from "react-masonry-css";
import _ from "lodash";
class Cards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      randomCards: [],
      flippedCards: [],
      modalCard: {},
      audioUrl: "",
      winnerCard: false,
      newModal: false,
      winner: false,
    };
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      winnerCard: !this.state.winnerCard,
    });
  };

  static comparer = (otherArray) => {
    return function (current) {
      return (
        otherArray.filter(function (other) {
          return other.player_id === current.player_id;
        }).length === 0
      );
    };
  };

  // sound to play initially when 1st card is played
  componentDidMount() {
    let roomData = this.props.gameReducer.roomObj;
    let totalPlayedCards = roomData.game_state.played_cards;
    this.playSoundOnNewCard(roomData, totalPlayedCards);
  }
  getWinnerUser = () => {
    let roomData = this.props.gameReducer.roomObj;
    let totalPlayedCards = roomData.game_state.played_cards;
    const winnerUser = totalPlayedCards.find((user) => user.winner === true);
    let winnerUserOfGame = roomData.users.find(
      (user) => user.player_id === winnerUser.player_id
    );
    return winnerUserOfGame;   
  };

  playSoundOnNewCard(roomData, totalPlayedCards) {
    if (
      roomData &&
      (roomData.game_state.status === "Playing" ||
        roomData.game_state.status === "Reading" ||
        roomData.game_state.status === "Result")
    ) {
      let roomObj = roomData;
      let gameData = this.props.gameReducer;
      if (
        roomObj.game_state.played_cards.length > gameData.playerCards.length
      ) {
        const callAudioEl = document.getElementById("audioOnPlay");
        let result = roomObj.game_state.played_cards.filter(
          Cards.comparer(gameData.playerCards)
        );
        if (result && result.length > 0) {
          let sound = roomObj.users.filter(
            (user) => user.player_id === result[0].player_id
          );
          this.setState(
            {
              audioUrl:
                result && result[0].player_id && sound[0].audio_effect
                  ? sound[0].audio_effect
                  : "",
            },
            () => {
              if (callAudioEl) {
                callAudioEl
                  .play()
                  .then(() => {})
                  .catch(() => {});
              }
              this.props.setPlayerCards(totalPlayedCards);
            }
          );
        }
      }
      if (roomData.game_state.status === "Result") {
        if (!this.state.winner) {
          const winnerOfRound = this.getWinnerUser();

          this.setState(
            {
              audioUrl: winnerOfRound ? winnerOfRound.audio_effect : "",
              winner: true,
            },
            () => {
              const callAudioEl = document.getElementById("audioOnPlay");

              if (callAudioEl) {
                callAudioEl
                  .play()
                  .then(() => {})
                  .catch(() => {});
              }
            }
          );
        }
      }
    }
  }

  componentDidUpdate() {
    let roomData = this.props.gameReducer.roomObj;
    let flippedCardsRedux = this.props.gameReducer.flippedCards;
    if (roomData.game_state.status === "Reading") {
      let totalPlayedCards = roomData.game_state.played_cards;
      let rotatedCards = totalPlayedCards.filter(
        (card) => card.flipped === true
      );
      let cardTodisplay = "";
      if (rotatedCards && _.head(rotatedCards)) {
        cardTodisplay = rotatedCards[rotatedCards.length - 1];
      } else if (
        rotatedCards &&
        rotatedCards.length <= 0 &&
        this.state.modalCard !== "default"
      ) {
        cardTodisplay = roomData.game_state.played_cards ? "default" : "";
        this.setState({
          modalCard: "default",
        });
      }

      if (flippedCardsRedux && flippedCardsRedux.length > 0) {
        cardTodisplay = flippedCardsRedux[flippedCardsRedux.length - 1];
      }
      if (
        cardTodisplay &&
        this.state.modalCard &&
        (cardTodisplay.player_id !== this.state.modalCard.player_id ||
          this.state.modalCard !== cardTodisplay)
      ) {
        this.setState({
          modal: true,
          newModal: true,
          modalCard: cardTodisplay,
        });
      }
    }
    if (!this.state.newModal && roomData.game_state.status === "Result") {
      this.setState({
        modal: true,
        newModal: true,
        modalCard: roomData.game_state.played_cards
          ? roomData.game_state.played_cards[
              roomData.game_state.played_cards.length - 1
            ]
          : "",
      });
    }
    if (this.state.newModal && roomData.game_state.status === "PrePlay") {
      this.setState({
        modal: false,
        newModal: false,
        modalCard: {},
      });
    }
    if (this.state.newModal && roomData.game_state.status === "Evaluating") {
      this.setState({
        modal: false,
        newModal: false,
        modalCard: {},
      });
    }

    if (roomData?.game_state?.played_cards) {
      let totalPlayedCards = roomData.game_state.played_cards;
      // Sound when user play card
      this.playSoundOnNewCard(roomData, totalPlayedCards);
      let rotatedCards = totalPlayedCards.filter(
        (card) => card.flipped === true
      );

      if (rotatedCards.length > flippedCardsRedux.length) {
        if (flippedCardsRedux.length === 0) {
          this.props.setFlippedCard(rotatedCards);
        } else {
          // put new card in flipped cards
          let newCards = flippedCardsRedux.slice();

          let result = rotatedCards.filter(Cards.comparer(flippedCardsRedux));
          newCards.push(result[0]);
          this.props.setFlippedCard(newCards);
        }

        // if (this.state.modal) {
        //   this.setState({
        //     newModal: false,
        //     modalCard: {},
        //   });
        // }
      }
    }
  }

  getCards = (arr) => {
    let arrLength = arr.length;
    let newArr = [];
    for (let i = 0; i < 9; i++) {
      newArr.push(arr[i]);
    }
    return newArr;
  };

  getAllFlippedCards = () => {
    let roomData = this.props.gameReducer.roomObj;
    let totalPlayedCards = roomData.game_state.played_cards;
    let flippedCards = totalPlayedCards.filter((card) => card.flipped === true);
    return flippedCards;
  };

  getAllNewFlippedCards = (nextProps) => {
    let roomData = nextProps.gameReducer.roomObj;
    let totalPlayedCards = roomData.game_state.played_cards;
    let flippedCards = totalPlayedCards.filter((card) => card.flipped === true);
    return flippedCards;
  };

  render() {
    const { modalCard, audioUrl } = this.state;

    let roomData = this.props.gameReducer.roomObj;

    const flippedCards = this.getAllFlippedCards();
    if (roomData) {
      if (roomData.game_state) {
        if (roomData.game_state.status === "Over") {
          return <Redirect to={"/win"} />;
        }
        if (roomData.game_state.status === "PrePlay")
          return <Redirect to={"/game"} />;
      }
    }

    let totalPlayedCards = roomData.game_state.played_cards;
    const all_cards = this.getCards(totalPlayedCards);
    const allFlippedCards = [];
    const allOtherCards = [];
    all_cards &&
      all_cards.length > 0 &&
      all_cards.map((item) => {
        if (item && item.flipped) {
          allFlippedCards.push(item);
        } else {
          allOtherCards.push(item);
        }
      });

    let promptText = roomData.game_state.prompt.replace(/\[BLANK]/g, "____");
    let finalArr = [1, ...all_cards];
    let totalColumns = [
      { col: 0, zeroIndex: true },
      { col: 1, zeroIndex: false },
      { col: 2, zeroIndex: false },
      { col: 3, zeroIndex: false },
    ];
    return (
      <>
        <audio
          key={this.state.users}
          id="audioOnPlay"
          src={this.state.audioUrl}
        ></audio>
        {roomData.game_state.status !== "Result" && (
          <div className="game-cards">
            {allFlippedCards.length > 0 ? (
              <div className="w-100 games-card-content">
                {/* <Row xs="1" sm="2" md="2">
                  <Col md="4" lg="4">
                    <div className="games-card-gah-left">
                      <div className="blue-card">
                        <div className="d-flex align-items-center ">
                          <div className="bg-theme br-16 contentCard full">
                            <div className="text-highlight content">
                              <div>
                                <p className="promptText">{promptText}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md="8" lg="8">
                    <div className="games-card-gah-right">
                      <Row xs="1" sm="2" md="3">
                        {finalArr &&
                          finalArr.length > 0 &&
                          finalArr.map((data, index) => {
                            if (index !== 0) {
                              if (data && data.gif_url !== "") {
                                return (
                                  <Col className="mb-3">
                                    <div
                                      key={index}
                                      className="games-card-right-boxes"
                                    >
                                      {<GameCard normal {...data} />}
                                    </div>
                                  </Col>
                                );
                              }
                            }
                          })}
                      </Row>
                    </div>
                  </Col>
                </Row> */}

                <Masonry
                  breakpointCols={{ default: 4, 1440: 3 }}
                  className="my-masonry-grid"
                  columnClassName="my-masonry-grid_column"
                >
                  {finalArr &&
                    finalArr.length > 0 &&
                    finalArr.map((data, index) => {
                      if (index === 0) {
                        return (
                          <div className="card-col">
                            <div className="d-flex align-items-center ">
                              <div className="bg-theme br-16 contentCard full">
                                <div className="text-highlight content">
                                  <div>
                                    <p className="promptText">{promptText}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        if (data && data.gif_url !== "") {
                          return (
                            <div key={index} className="card-col">
                              <div className="game-card-gah">
                                {<GameCard normal {...data} />}
                              </div>
                            </div>
                          );
                        }
                      }
                    })}
                </Masonry>
              </div>
            ) : (
              <>
                <Row xs="1" sm="2" md="2">
                  <Col md="4" lg="4">
                    <div className="games-card-gah-left">
                      <div className="blue-card">
                        <div className="d-flex align-items-center ">
                          <div className="bg-theme br-16 contentCard full">
                            <div className="text-highlight content">
                              <div>
                                <p className="promptText">{promptText}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md="8" lg="8">
                    <div className="games-card-gah-right">
                      <Row xs="1" sm="2" md="3">
                        {/* <div className="cardsWrapper">
                          <div className="cards"> */}
                        {all_cards &&
                          all_cards.length > 0 &&
                          all_cards.map((data, index) => {
                            return (
                              <Col className="mb-3 px-2" xl={4} md={6}>
                                <div
                                  key={index}
                                  className="cardsWrapper games-card-right-boxes"
                                >
                                  {<GameCard {...data} />}
                                </div>
                              </Col>
                            );
                          })}
                        {/* </div>
                        </div> */}
                        {/* {finalArr &&
                    finalArr.length > 0 &&
                    finalArr.map((data, index) => {
                      if (index !== 0) {
                        if (data && data.gif_url !== "") {
                          return (
                            <Col  className="mb-3">
                            <div key={index} className="games-card-right-boxes">
                                {<GameCard normal {...data} />}
                            </div>
                            </Col>
                          );
                        }
                      }
                    })} */}
                      </Row>
                    </div>
                  </Col>
                </Row>
                {/* <div className="d-flex align-items-center contentCardWrapper">
                  <div className="bg-theme br-16 contentCard">
                    <div className="text-highlight content">
                      <div>
                        <p className="promptText">{promptText}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="cardsWrapper">
                  <div className="cards">
                    {all_cards &&
                      all_cards.length > 0 &&
                      all_cards.map((data, index) => {
                        return (
                          <div key={index} className="card-col">
                            {<GameCard {...data} />}
                          </div>
                        );
                      })}
                  </div>
                </div> */}
              </>
            )}
          </div>
        )}

        <CardMove
          className="flipModal"
          roomData={roomData}
          promptText={promptText}
          modalCard={modalCard}
          isOpen={this.state.newModal}
          toggle={this.toggle}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setFlippedCard: (data) => dispatch(gameAction.setFlippedCard(data)),
    setPlayerCards: (data) => dispatch(gameAction.setPlayerCards(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cards);
